export const GET_PRODUCTS = 'app/AccountSubscriptions/GET_PRODUCTS';
export const GET_USER_SUBSCRIPTIONS = 'app/AccountSubscriptions/GET_USER_SUBSCRIPTIONS';
export const GET_SUBSCRIPTIONS = 'app/AccountSubscriptions/GET_SUBSCRIPTIONS';
export const GET_USER_CARDS = 'app/AccountSubscriptions/GET_USER_CARDS';
export const CANCEL_SUBSCRIPTION = 'app/AccountSubscriptions/CANCEL_SUBSCRIPTION';
export const ADD_SUBSCRIPTION = 'app/AccountSubscriptions/ADD_SUBSCRIPTION';
